module.exports = __webpack_public_path__ + "img/yep.52b9e9d4.png";